import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';
import { TENANT_ROUTES } from '../constants';
import { appLayoutRoute } from '../../layout';
import { useAuthStore } from '@/features/auth/stores/auth.store';
import { hasRole } from '@/shared/utils/rbac.utils';
import ROUTE_CONSTANTS from '@/shared/constants/route.constants';
import { ROLES } from '@/features/rbac';

/** Tenant management is restricted to super admins only (not power admins / managers). */
const checkSuperAdmin = () => {
  const user = useAuthStore.getState().user;
  if (!hasRole(user, ROLES.SUPER_ADMIN)) {
    throw redirect({ to: ROUTE_CONSTANTS.ROOT, replace: true });
  }
};

const tenantsListRoute = createRoute({
  path: TENANT_ROUTES.LIST,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages/TenantsListPage').then(m => ({
      default: m.TenantsListPage,
    }))
  ),
  beforeLoad: async () => {
    checkSuperAdmin();
  },
});

const tenantCreateRoute = createRoute({
  path: TENANT_ROUTES.CREATE,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages/TenantCreatePage').then(m => ({
      default: m.TenantCreatePage,
    }))
  ),
  beforeLoad: async () => {
    checkSuperAdmin();
  },
});

const tenantDetailRoute = createRoute({
  path: TENANT_ROUTES.DETAIL,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages/TenantDetailPage').then(m => ({
      default: m.TenantDetailPage,
    }))
  ),
  beforeLoad: async () => {
    checkSuperAdmin();
  },
});

export const tenantEditRoute = createRoute({
  path: TENANT_ROUTES.EDIT,
  getParentRoute: () => appLayoutRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    from: search.from === 'detail' ? ('detail' as const) : ('list' as const),
  }),
  component: lazyRouteComponent(() =>
    import('../pages/TenantEditPage').then(m => ({
      default: m.TenantEditPage,
    }))
  ),
  beforeLoad: async () => {
    checkSuperAdmin();
  },
});

export const tenantRoutes = [
  tenantsListRoute,
  tenantCreateRoute,
  tenantDetailRoute,
  tenantEditRoute,
];

export default tenantRoutes;
